;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a0806b5e-f4dd-4142-8cd1-6e70be95acae",e._sentryDebugIdIdentifier="sentry-dbid-a0806b5e-f4dd-4142-8cd1-6e70be95acae")}catch(e){}}();import { Hub, BrowserClient } from '@sentry/browser';
import '../_virtual/_sentry-release-injection-file.js';

let hub;
const initializeSentry = () => {
    hub = new Hub(new BrowserClient({
        environment: process.env.REACT_APP_STAGE ?? 'prod',
        release: "3.32.0",
        dsn: 'https://3d1329337ecc4281931bb5fcf7c3d5e2@sentry.io/5180738',
        sampleRate: 1,
    }));
};
const withSentryHub = () => {
    return hub;
};

export { initializeSentry, withSentryHub };
//# sourceMappingURL=sentry.js.map
